// Google OAuth Configuration
// You need to set up Google OAuth in Google Cloud Console and get your client ID

export const GOOGLE_CONFIG = {
  // Replace this with your actual Google OAuth Client ID
  // Get it from: https://console.cloud.google.com/apis/credentials
  CLIENT_ID: process.env.REACT_APP_GOOGLE_CLIENT_ID || '1001651706321-565n0l84cs7jp2dcqibuloljrludunp1.apps.googleusercontent.com',
  
  // Your authorized email address for admin access
  AUTHORIZED_EMAIL: 'eli.elhadad@gmail.com' // Replace with your actual email
};

// Instructions for setup:
// 1. Go to Google Cloud Console (https://console.cloud.google.com/)
// 2. Create a new project or select existing one
// 3. Enable Google+ API
// 4. Go to Credentials and create OAuth 2.0 Client ID
// 5. Set authorized origins to your domain (localhost:3000 for development)
// 6. Copy the Client ID and set it as REACT_APP_GOOGLE_CLIENT_ID in your .env file
// 7. Update AUTHORIZED_EMAIL with your actual email address
